module.exports = __webpack_public_path__ + "static/media/shilu.20ec2962.jpg";